/**
 * Created by mac on 12/15/20
 */

const HighlightView = cc.Node.extend({
    ctor: function (highlight) {
        this._super();

        this.highlight = highlight;

        if (typeof Map2dLocation !== "undefined" && Map2dLocation.currentLocation && ["undersea", "undersea2", "undersea3"].indexOf(cleverapps.meta.selectedLocationId()) !== -1) {
            this.setAnchorPoint(0.52, 0.44);
        } else {
            this.setAnchorPoint(0.5, 0.5);
        }

        this.setContentSize2(cleverapps.styles.Map2dView.cell);

        this.setLocalZOrder(cleverapps.config.name === "wordsoup" ? 1 : -1);

        this.setRecCascadeColorEnabled();

        highlight.onMove = this.createListener(this.move.bind(this));
        highlight.hide = this.createListener(this.hide.bind(this));
        highlight.show = this.createListener(this.show.bind(this));
        highlight.onRemove = this.createListener(this.removeFromParent.bind(this));
        highlight.onChangeShape = this.createListener(this.rebuildViews.bind(this));
        highlight.up = this.createListener(this.up.bind(this));

        if (this.highlight.isErrorLight) {
            this.setColor(cleverapps.styles.COLORS.COLOR_RED);
        }

        this.views = this.addViews();
    },

    rebuildViews: function () {
        Object.keys(this.views).forEach((key) => {
            this.views[key].removeFromParent();
        });
        this.views = this.addViews();
    },

    addViews: function () {
        const views = {};

        const multiCell = this.highlight.unit && this.highlight.unit instanceof Unit && this.highlight.unit.findComponent(MultiCell);
        if ((typeof Editor !== "undefined" && Editor.currentEditor || cleverapps.config.demoMode) && this.highlight.getShape() !== FamiliesHelper.ShapeCell) {
            this.highlight.getShape().forEach((shape) => {
                const view = new cleverapps.Spine(bundles.highlight_animations.jsons.highlight_json);
                const iso = Map2dInnerView.IsoToScreen(
                    shape.x,
                    shape.y
                );
                view.setPosition(
                    this.width / 2 + iso.x,
                    this.height / 2 + iso.y
                );

                view.setSkin("tile_light_1");
                view.setAnimation(0, this.getAnimation(this.highlight.x, this.highlight.y, view), true);
                this.addChild(view);

                views[`${shape.x}_${shape.y}`] = view;
            });
        } else if ((cleverapps.config.name === "wordsoup" || typeof Editor !== "undefined" && Editor.currentEditor) && multiCell) {
            multiCell.shape.forEach((shape) => {
                const view = new cleverapps.Spine(bundles.highlight_animations.jsons.highlight_json);
                const iso = Map2dInnerView.IsoToScreen(
                    shape.x,
                    shape.y
                );

                if (shape.x === 0 && shape.y === 0) {
                    const headText = cleverapps.UI.generateOnlyText("*", cleverapps.styles.FONTS.WHITE_TEXT);
                    headText.setAlignment({
                        x: { align: "center" },
                        y: { align: "center" }
                    });
                    view.addChild(headText);
                }

                view.setAlignment(
                    this.width / 2 + iso.x,
                    this.height / 2 + iso.y
                );

                view.setSkin("tile_light_1");
                view.setAnimation(0, this.getAnimation(this.highlight.x, this.highlight.y, view), true);
                this.addChild(view);

                views[`${shape.x}_${shape.y}`] = view;
            });
        } else {
            const view = new cleverapps.Spine(bundles.highlight_animations.jsons.highlight_json);
            view.setAlignment(this.width / 2, this.height / 2);
            view.setSkin(this.highlight.getShape() !== FamiliesHelper.ShapeCell ? "tile_light_2" : "tile_light_1");
            view.setAnimation(0, this.getAnimation(this.highlight.x, this.highlight.y, view), true);
            this.addChild(view);

            if (this.highlight.getShape() === FamiliesHelper.ShapeSquare) {
                view.x += this.width / 2;
            }

            views["0_0"] = view;
        }

        return views;
    },

    hide: function () {
        this.visible = false;
    },

    show: function () {
        this.visible = true;
    },

    up: function () {
        this.setLocalZOrder(1);
    },

    move: function (x, y, silent) {
        Object.keys(this.views).forEach((pos) => {
            const view = this.views[pos];
            view.setAnimation(0, this.getAnimation(x, y, view), true);
        });

        this.stopAllActions();
        const mapView = Map2d.currentMap.getMapView();
        const position = mapView.alignInGrid(x, y);
        if (silent) {
            this.setAlignment(position);
        } else {
            this.runAction(new cc.MoveTo(0.05, position.x, position.y));
        }

        if (this.highlight.intersects && Object.keys(this.highlight.intersects).length || this.highlight.isErrorLight || this.highlight.error) {
            Object.keys(this.views).forEach((pos) => {
                const view = this.views[pos];
                view.setColor(cleverapps.styles.COLORS.WHITE);
            });

            Object.keys(this.highlight.intersects || this.views).forEach((pos) => {
                const view = this.views[pos];
                view.setColor(cleverapps.styles.COLORS.COLOR_RED);
            });
        } else {
            Object.keys(this.views).forEach((pos) => {
                const view = this.views[pos];
                view.setColor(cleverapps.styles.COLORS.WHITE);
            });
        }
    },

    getAnimation: function (x, y, view) {
        const animation = (Map2d.currentMap.getTerrainCode(x, y) === "s" && !this.highlight.error && !this.highlight.isErrorLight) ? "blue" : "yellow";
        return this.highlight.drag && view.hasAnimation(`${animation}_dragging`) ? `${animation}_dragging` : animation;
    }
});